import ENV from "./ENV";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import timeHelpers from "app/utils/timeHelpers";
import richTextHelpers from "app/utils/richTextHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
// import filterHelpers from 'app/utils/filterHelpers'
import storageActions from "app/utils/storageActions";
import store from "app/redux/store";

let valueHelpers = {
  populateFullFamily(value, values) {
    value = valueHelpers.populateFamilyRecursively(value, values, "parents");
    value = valueHelpers.populateFamilyRecursively(value, values, "children");
    console.log(value);
    return value;
  },
  populateFamilyRecursively(value, values, genKey = "parents") {
    let genIdKey = genKey == "parents" ? "parent_ids" : "child_ids";
    let genIds = value[genIdKey];
    if (!!genIds?.length) {
      let nextGen = values.filter((v) => genIds.includes(v.id));
      nextGen.map((v) => {
        return valueHelpers.populateFamilyRecursively(v, values, genKey);
      });
      value[genKey] = nextGen;
    }
    return value;
  },
  // getColor(value = {}, key = "color") {
  //   if (!value) value = {};
  //   if (typeof value.id == "string" && value.id.includes("ftue"))
  //     return colors.empty;
  //   let color = value.color && valueHelpers.colorAsHex(value.color);
  //   if ((!color || key == "parentColors") && !!value.parentColors?.length) {
  //     let hexes = value.parentColors.map((c) => valueHelpers.colorAsHex(c));
  //     color = colorHelpers.averageColor(hexes);
  //   }
  //   if ((!color || key == "ancestorColors") && !!value.ancestorColors?.length) {
  //     let hexes = value.ancestorColors.map((c) => valueHelpers.colorAsHex(c));
  //     // color = colorHelpers.averageColor(hexes)
  //     color = hexes[0];
  //     // console.log(value.text, color)
  //     // if(hexes.length > 1){
  //     //   console.log(hexes, value)
  //     // }
  //   }
  //   if ((!color || key == "familyColors") && !!value.familyColors?.length) {
  //     let hexes = value.familyColors.map((c) => valueHelpers.colorAsHex(c));
  //     color = colorHelpers.averageColor(hexes);
  //   }
  //   if (!color) color = colors.trim;
  //   return color;
  // },
  getCycle(value) {
    let cycle = value.cycle;
    if (!!cycle || cycle == 0) {
      return cycle;
    }
    // return ENV.CYCLE;
    // if (ENV.STACK_PROGRESS) return ENV.CYCLE;
    // else return 0;
    if (valueHelpers.isProject(value)) {
      return 0;
    }
    return ENV.CYCLE;
  },
  getRipe(value) {
    return false;
    return value.percent < 1 && value.percent >= 0.999;

    let ripe = false;
    let completedAt = valueHelpers.getCompletedAt(value);
    if (!!completedAt) {
      ripe = true;
    } else {
      let cycle = valueHelpers.getCycle(value);
      if (cycle !== 0) {
        let { progressions, incompleteChildren } =
          valueHelpers.getNotches(value);
        if (progressions.length >= cycle) {
          ripe = true;
        }
      }
    }
    return ripe;
  },
  getNotchArray(value) {
    // let { progressions, incompleteChildren, } = valueHelpers.getNotches(value)

    let notches = [];
    let progressions = value?.progress_at?.length || 0;
    let steps = value?.cycle || 7;

    if (!!value?.completed_at) {
      return [1];
    }

    if (!!value?.non_note_child_ids?.length) {
      // steps = progressions + value?.child_ids?.length;
      steps = progressions + value?.non_note_child_ids?.length;
    }

    // for (let i = 1; i <= steps; i++) {
    //   if (i <= progressions) {
    //     notches.push(1);
    //   } else {
    //     notches.push(0);
    //   }
    // }
    let step = 1.0 / steps;
    for (let i = step - 0.0001; i <= 1.0; i += step) {
      if (i <= value.percent) {
        notches.push(1);
      } else {
        notches.push(0);
      }
    }

    // console.log(value, notches);

    return notches;
  },
  getNotches(value) {
    let progressions = [];
    let incompleteChildren =
      valueHelpers.isReference(value) || valueHelpers.isInfinite(value)
        ? []
        : valueHelpers
            .getChildren({ value })
            .filter((c) => !valueHelpers.getCompletedAt(c) && !c.archived_at)
            .filter((c) => !valueHelpers.isSnoozed(c))
            .filter((c) => !valueHelpers.isInfinite(c) || c.completed); // no infinite child notches (unless complete?)

    if (valueHelpers.isInfiniteTracker(value)) {
      return {
        progressions,
        incompleteChildren: ["∞"],
        // incompleteChildren: new Array(incompleteChildren.length).fill("∞"),
      };
    }

    let inherit = true;
    let condense = false;
    if (valueHelpers.isProject(value)) {
      // hide completed progressions if value is project
      condense = true;
    } else {
      if (!ENV.STACK_PROGRESS) {
        // inherit = false;
      }
    }
    progressions = valueHelpers.getProgressions({
      value,
      condense,
      inherit,
      timeline: valueHelpers.isInfinite(value),
      includePastRevisions: valueHelpers.isInfinite(value),
    });

    // hide open children notches if child is infinite
    // incompleteChildren = incompleteChildren.filter(
    //   (c) => !valueHelpers.isInfinite(c, false)
    // );

    // if (valueHelpers.isInfinite(value)) {
    if (valueHelpers.isProject(value)) {
      // condense progressions into incomplete children
      incompleteChildren = incompleteChildren.map((c) => {
        // if (value.id == 700) console.log("incompleteChild", c, progressions);
        let prevIteration = progressions.find((p) => p.root_id == c.root_id);
        if (prevIteration) {
          // remove it from progressions
          progressions = progressions.filter((p) => p.root_id != c.root_id);
          // and add iterations to incomplete child
          return {
            ...c,
            iterations: (prevIteration.iterations || 0) + 1,
          };
        }
        return c;
      });
    }

    return {
      progressions,
      incompleteChildren,
    };
  },
  color(value, inheritColor = true, fallback = "#333") {
    let color = valueHelpers.colorAsHex(value.colorString || value.color || "");
    // console.log(value.colorString)

    let inspect = false;
    // inspect = value.id == 157 || value.id == 67

    if (inspect) {
      console.log("color()", value.id, inheritColor ? "inherit" : "no inherit");
    }

    // if(inheritColor && !color && !!value.parents && value.parents.length){
    if (inheritColor) {
      if (!!value.parents && value.parents.length) {
        color = valueHelpers.colorFromParents(value);
      } else if (!!value.inheritedColor) {
        color = value.inheritedColor;
        if (!!value.color) {
          color = colorHelpers.averageColor([
            value.inheritedColor,
            value.color,
          ]);
        }
      }
    }

    if (!color && !!fallback) color = fallback;

    return color;
  },
  iconColor(value, color = null, colorScheme) {
    let colors = colorHelpers.allColors(colorScheme);
    // if (typeof value.id == "string" && value.id.includes("ftue"))
    //   color = colors.placeholder;
    color = color || value.color || value.inheritedColor || colors.trim;

    // let opacity = ENV.LIGHT ? 0.4 : 0.2
    let opacity = 0.2;
    // let colorString = value.colorString
    // if(!colorString){
    //   let inheritedColor = valueHelpers.hexAsColor(value.inheritedColor)
    //   colorString = valueHelpers.hexAsColor(inheritedColor)
    // }

    // if(colorString == 'blue') opacity = 0.4
    // if(colorString == 'navy') opacity = 0.6
    // if(colorString == 'purple') opacity = 0.5
    // if(colorString == 'black') opacity = 0.6

    // if(ENV.LIGHT){
    //   if(colorString == 'lime') opacity = 0.3
    //   if(colorString == 'green') opacity = 0.8
    //   if(colorString == 'brown') opacity = 0.8
    // if(colorString == 'yellow') opacity = 0.1
    //   if(colorString == 'magenta') opacity = 0.6
    // }
    // else {
    //   if(colorString == 'lime') opacity = 0.15
    // }
    // if(ENV.LIGHT) opacity += 0.3
    opacity = 0.65;

    let darkenBy = ENV.DARK ? 0.9 : 0.9;
    darkenBy = 0.85;
    // darkenBy = 0.1
    // darkenBy = colors.darkenBy
    color = colorHelpers.modifyHex(color, darkenBy);

    return { color, opacity };
  },
  colorAsHex(color = "", colorScheme = null) {
    if (!color) color = "";
    if (color.startsWith("#")) return color;
    let hex = colorHelpers.allColors(colorScheme)[color];
    return hex;
  },
  hexAsColor(hex = "", fallback = null) {
    if (!hex) hex = "";
    let allColors = colorHelpers.allColors();
    let color = Object.keys(allColors).find((key) => allColors[key] === hex);
    if (!color) {
      color = fallback !== null ? fallback : hex;
    }
    return color;
  },
  colorOptions() {
    return Object.keys(colorHelpers.allColors());
  },
  fontColor(value, bgColor = null) {
    // if(typeof value.id == 'string' && value.id.includes('ftue')) return colors.placeholder
    if (!value.id || (typeof value.id == "string" && value.id.includes("ftue")))
      return colors.trim;
    let lightColors = [
      // 'white', 'yellow',
      // 'pink', 'orange',
      // 'cream', 'gray'
    ];
    if (lightColors.includes(value.color)) {
      // return colors.fill
      return colors.darkest;
    }
    if (ENV.DARK) {
      return colors.lightForeground;
    } else if (!!bgColor) {
      let intensity = colorHelpers.rgbaAsFloat(
        colorHelpers.hexToRgbaString(bgColor),
      );
      if (intensity > 0.75) {
        return "#fbfbfb";
      }
    }

    // return colors.lightForeground
    return colors.empty;
  },
  colorFromParents(value) {
    let color = "";
    if (!!value.parents && value.parents) {
      let inspect = false;
      // inspect = value.id == 157 || value.id == 67
      let parentColors = value.parents
        .map((p) => valueHelpers.color(p, true, null))
        .filter((c) => !!c);
      if (inspect)
        console.log(
          "get color from parents",
          value,
          value.parents,
          parentColors,
        );
      color = colorHelpers.averageColor(parentColors, inspect);
    }
    return color;
  },
  applyColors(values) {
    let coloredValues = []; // keep track of parent colors
    return values
      .sort((a, b) => {
        return a.level < b.level ? 1 : -1;
      })
      .map((value) => {
        let coloredValue = valueHelpers.colorize(value, coloredValues);
        coloredValues.push(coloredValue); // keep track
        coloredValue.revisions = coloredValue.revisions?.map((r) =>
          valueHelpers.colorize(r, coloredValues),
        );
        return coloredValue;
      });
  },
  applyColorsFromFamily(value) {
    let parents = valueHelpers.getGenerationsRecursively(value, "parents");
    let children = valueHelpers.getGenerationsRecursively(value, "children");
    // let revisions = value.revisions
    // let values = [...parents, value, ...revisions, ...children].filter(x => !!x)
    let values = [...parents, value, ...children].filter((x) => !!x);

    values = valueHelpers.applyColors(values);
    // console.log(values)

    value = valueHelpers.colorize(value, values);
    value = valueHelpers.remapGenerationsRecursively(value, values, "parents");
    value = valueHelpers.remapGenerationsRecursively(value, values, "children");
    // value = valueHelpers.remapGenerationsRecursively(value, values, 'revisions')
    value.revisions = (value.revisions || []).map((r) => ({
      ...r,
      color: value.color,
      inheritColor: value.inheritColor || [],
    }));

    return value;
  },
  getGenerationsRecursively(value, genKey) {
    let values = [];
    !!value[genKey] &&
      value[genKey].map((v) => {
        values.push(v);
        let greatGen = valueHelpers.getGenerationsRecursively(v, genKey);
        values = [...values, ...greatGen];
      });
    return values;
  },
  remapGenerationsRecursively(value, values, genKey) {
    if (!!value[genKey] && !!value[genKey].length) {
      value[genKey] =
        value[genKey] &&
        value[genKey]
          .filter((x) => !!x)
          .map((v) => {
            if (!!!v) return null;
            let remappedValue = values.find((mv) => mv.id == v.id);
            if (genKey != "revisions") {
              remappedValue = valueHelpers.remapGenerationsRecursively(
                remappedValue,
                values,
                genKey,
              );
            }
            return remappedValue;
          })
          .filter((x) => !!x);
    }

    if ((genKey = "children")) {
      // if(value.id == 184) console.log('force!! on', value)
      // if(value.id == 184) console.log(value.parents, value.parent_ids)
      if (
        (!value.parents || !value.parents.length) &&
        !!value.parent_ids?.length
      ) {
        // let idKey = genKey == 'parents' ? 'parent_ids' : (genKey == 'children' ? 'child_ids' : '')
        let idKey = "parent_ids";
        if (!!value[idKey] && value[idKey].length) {
          let gen = values
            .filter((v) => value[idKey].includes(v.id))
            .filter((x) => !!x);
          gen = gen.map((v) => {
            return valueHelpers.remapGenerationsRecursively(
              v,
              values,
              "parents",
            );
          });
          value["parents"] = gen;
          value = valueHelpers.colorize(value, values);
          // console.log(value)
        }
      }
    }
    return value;
  },
  colorize(value, coloredValues) {
    let coloredValue = {
      ...value,
      colorString: value.colorString,
      parents: (value.parents || []).map((v) => {
        let coloredParent = coloredValues.find((cv) => v.id == cv.id);
        let color =
          coloredParent?.color || coloredParent?.inheritedColor || undefined;
        let inheritedColor = coloredParent?.inheritedColor || undefined;
        return { ...v, color, inheritedColor };
      }),
      children: (value.children || []).map((v) => ({
        ...v,
        color: coloredValues.find((cv) => v.id == cv.id)?.color,
      })),
      parentColors: (value.parents || []).map(
        (v) => coloredValues.find((cv) => v.id == cv.id)?.color,
      ),
    };
    coloredValue.inheritedColor = valueHelpers.color(coloredValue, true, null);
    coloredValue.color = valueHelpers.color(coloredValue, false, null);
    return coloredValue;
  },
  sortByTimeline(values = [], onlyRecentRevisions = true) {
    // console.log(values)
    // console.log('--------')
    let timestampedValues = values
      .sort((a, b) => {
        // lower levels first so timeline timestamps can propagate upwards
        return a.level >= b.level ? 1 : -1;
      })
      .map((value) => {
        let inspect = false;
        // inspect = value.id == 54 || value.id == 299
        // if(inspect) console.log('inspecting: ', value)
        let timeline = textHelpers.newestFirst(value.timeline, "timestamp");
        let children = textHelpers.newestFirst(
          values.filter((v) => value.child_ids?.includes(v.id)),
          "timestamp",
          "updated_at",
        );
        let recentChild = children.length ? children[0] : null;

        if (inspect) console.log(value.text, value.child_ids);

        // let timestamp = recentChild ? recentChild.updated_at : (timeline.length ? timeline[0].timestamp : value.updated_at)
        let timestamp = timeline.length
          ? timeline[0].timestamp
          : value.updated_at;

        if (inspect) console.log(recentChild, timestamp);

        if (!!recentChild?.id) {
          if (!!recentChild.timestamp && recentChild.timestamp > timestamp) {
            timestamp = recentChild.timestamp;
          }
        }
        value.recentChild = recentChild;

        // surface recently unsnoozed
        if (!!value.snooze_until && !valueHelpers.isSnoozed(value)) {
          if (value.snooze_until > timestamp) {
            timestamp = value.snooze_until;
          }
        }

        // value.timestamp = timestamp

        // let timestamps = children.map(c => c.timestamp == timestamp ? null : c.timestamp).filter(t => !!t)
        let timestamps = children.map((c) => c.timestamp);
        // let updatedAt = new Date(value.updated_at).getTime()
        // timestamps.push(updatedAt)
        // timestamps.push(value.updated_at)

        if (!timestamps.includes(timestamp)) {
          timestamps.push(timestamp);
        }

        timestamps = textHelpers.newestFirst(timestamps);

        value.timestamps = timestamps;

        value.timestamp = timestamps[0];

        // if(!value.timeline?.length){
        value.timeline = valueHelpers.timeline(true, false, value, values);
        // }

        // console.log(value)

        // if(typeof value.id == 'string' && value.id.includes('ftue')){
        //   value.timestamp = value.id
        // }
        // console.log(value.id,value.timestamp)

        // update values so parents can reference our new timestamp
        values[values.findIndex((v) => v.id == value.id)] = value;

        return value;
      });

    timestampedValues = valueHelpers.applyLevels(timestampedValues);

    // console.log(timestampedValues)

    let sortedValues = timestampedValues.sort((a, b) => {
      // higher levels first so hidden filters propagate down
      if (a.level != b.level) {
        return a.level < b.level ? 1 : -1;
      }

      if (a.timestamp == b.timestamp) {
        for (let i = 0; i < a.timestamps.length; i++) {
          let aTimestamp = a.timestamps[i];
          let bTimestamp = b.timestamps[i];
          if (aTimestamp != bTimestamp) {
            if (!bTimestamp || aTimestamp > bTimestamp) {
              return -1;
            } else {
              return 1;
            }
          }
        }
      }
      // console.log(a, b, (a.timestamp <= b.timestamp ? 1 : -1))
      return a.timestamp <= b.timestamp ? 1 : -1;
    });

    // if(onlyRecentRevisions){
    //   sortedValues = valueHelpers.onlyRecentRevisions(sortedValues)
    // }

    // console.log(sortedValues)
    return sortedValues;

    // not in use
    return values.sort((a, b) => {
      let aTimeline = textHelpers.newestFirst(a.timeline, "timestamp");
      let bTimeline = textHelpers.newestFirst(b.timeline, "timestamp");
      // let aChildren = !!a.children ? textHelpers.newestFirst(a.children, 'updated_at') : []
      let aChildren = textHelpers.newestFirst(
        values.filter((v) => a.child_ids.includes(v.id)),
        "updated_at",
      );
      // let bChildren = !!b.children ? textHelpers.newestFirst(b.children, 'updated_at') : []
      let bChildren = textHelpers.newestFirst(
        values.filter((v) => b.child_ids.includes(v.id)),
        "updated_at",
      );
      let inspect = false;
      // if(a.id == 67 || a.id == 10) inspect = true
      let compA = aChildren[0]
        ? aChildren[0].updated_at
        : aTimeline.length
          ? aTimeline[0].timestamp
          : a.updated_at;
      let compB = bChildren[0]
        ? bChildren[0].updated_at
        : bTimeline.length
          ? bTimeline[0].timestamp
          : b.updated_at;
      // if(inspect){
      //   let keyA = aChildren[0] ? 'aChildren[0].updated_at' : (a.timeline.length ? 'a.timeline[a.timeline.length-1].timestamp' : 'a.updated_at')
      //   console.log('sorting notes a:', a, keyA, compA)
      //   let keyB = bChildren[0] ? 'bChildren[0].updated_at' : (b.timeline.length ? 'b.timeline[b.timeline.length-1].timestamp' : 'b.updated_at')
      //   console.log('sorting notes b:', b, keyB, compB)
      // }
      return compA <= compB ? 1 : -1;
    });
  },
  onlyRecentRevisions(values) {
    return values;
    let current = [];
    // console.log('onlyRecentRevisions', values)
    values.forEach((v) => {
      let revisions = valueHelpers.revisions(true, v, values);
      let allRevisionIds = revisions
        .map((r) => [...r.revision_ids, r.id])
        .flat();
      if (!allRevisionIds.includes(v.id)) allRevisionIds.push(v.id);
      allRevisionIds = allRevisionIds.sort();
      // console.log(v.text, allRevisionIds)
      // if(v.id == 3 || v.id == 5) console.log(v, allRevisionIds, revisions)
      if (allRevisionIds.length == 1) {
        current.push(v);
      } else {
        // console.log('----', v, allRevisionIds)
        let topRevisionId = allRevisionIds[allRevisionIds.length - 1];
        if (v.id == topRevisionId) {
          current.push(v);
        } else {
          console.log("excluding revision:", v);
        }
      }
    });
    return current;
  },
  topLevel(values) {
    let topLevel = 0;
    values.map((v) => {
      let level = valueHelpers.getLevel(v);
      if (level > topLevel) {
        topLevel = level;
      }
    });
    return topLevel;
  },
  getLevelIds(values, fullValues = false, fromBottom = true) {
    let levelIds = {};
    values.forEach((v) => {
      let level = valueHelpers.getLevel(v, fromBottom);
      if (!!levelIds[level]) {
        if (fullValues) levelIds[level].push(v);
        else levelIds[level].push(v.id);
      } else {
        if (fullValues) levelIds[level] = [v];
        else levelIds[level] = [v.id];
      }
    });
    return levelIds;
  },
  // applyAncestorIds(values){
  //   values = values.map(v => {
  //     let ancestorId = valueHelpers.getAncestorId(v)
  //     return {
  //       ...v,
  //       ancestor_ids: ancestorIds,
  //     }
  //   })
  //   return values
  // },
  // getAncestorIds(value){
  //   // this returns all ancestors, not just top-level ones
  //   let values = store.getState().values
  //   let ancestorIds = []
  //   let parentIds = value.parent_ids
  //   while(!!parentIds?.length){
  //     ancestorIds = [...ancestorIds, ...parentIds]
  //     let parents = values.filter(v => parentIds.includes(v.id))
  //     parentIds = parents.reduce((ids,v) => [...ids, ...v.parent_ids])
  //     parentIds = parentIds.filter(id => !ancestorIds.includes(id))
  //     // parentIds = parentIds.filter((id, i, ar) => ar.indexOf(id) === i) // uniq
  //   }
  //   return ancestorIds
  // },
  getTopLevel(levelIds) {
    let levels = Object.keys(levelIds).sort();
    let topLevel = levels[levels.length - 1];
    return parseInt(topLevel);
  },
  getLevel(value, fromBottom = true, values = null) {
    return value.level;
    values = values || store.getState().values;
    let level = 0;
    level = 0;
    let nextGen = fromBottom
      ? valueHelpers.getChildren({ value, values })
      : valueHelpers.getParents({ value, values });
    nextGen = valueHelpers.filterToActive({ values: nextGen });

    // let allGenIds = nextGen.map(v => v.id)
    while (nextGen?.length) {
      level += 1;
      let nextNextGen = [];
      nextGen.forEach((v) => {
        let ng = fromBottom
          ? valueHelpers.getChildren({ value: v })
          : valueHelpers.getParents({ value: v });
        ng = valueHelpers.filterToActive({ values: ng });
        nextNextGen = [...nextNextGen, ...ng];
      });
      nextGen = nextNextGen;
    }

    return level;
  },
  filterToActive({ values, removeHidden = true, removeSubTasks = false }) {
    let openValues = values.filter((v) => {
      // let isHidden = removeHidden && filterHelpers.isHidden(v)
      // let isSubTask = removeSubTasks && filterHelpers.isSubTask(v)
      let isHidden = removeHidden && valueHelpers.isHidden(v);
      let isSubTask = removeSubTasks && valueHelpers.isSubTask(v);
      let isArchived = valueHelpers.isArchived(v);
      let isCompleted = !!valueHelpers.getCompletedAt(v);

      if (isCompleted || isArchived || isHidden || isSubTask) {
        return false;
      }
      return true;
    });
    return openValues;
  },
  isArchived(value, recursively = true) {
    if (!!value.archived_at) return true;
    if (recursively) {
      let allParentsArchived = false;
      if (!!value.parent_ids?.length) allParentsArchived = true;
      for (let parent of valueHelpers.getParents({ value })) {
        if (!valueHelpers.isArchived(parent, recursively)) {
          allParentsArchived = false;
          break;
        }
      }
      if (allParentsArchived) {
        return true;
      }
    }
    return false;
  },
  isHidden(value, recursively = true) {
    let { values, preferences } = store.getState();
    let { hiddenIds } = preferences;

    let tempHiddenIds = hiddenIds?.length ? [...hiddenIds] : [];
    let hiddenRootIds = values
      .filter((v) => tempHiddenIds.includes(v.id))
      .map((v) => v.root_id);

    values
      .filter((v) => hiddenRootIds.includes(v.root_id))
      .forEach((value) => {
        valueHelpers.getDescendants(value).forEach((c) => {
          if (
            !!c.parent_ids.length &&
            !valueHelpers
              .getParents({ value: c })
              .some((p) => !hiddenRootIds.includes(p.root_id))
          ) {
            // tempHiddenIds.push(c.id)
            hiddenRootIds.push(c.root_id);
          }
        });
      });

    if (hiddenRootIds.includes(value.root_id)) {
      return true;
    }
    return false;
  },
  isSubTask(value, values = null) {
    values = values || store.getState().values;
    let projectIds = values.filter((v) => v.cycle === 0).map((v) => v.id);
    if (value.cycle == 1) {
      return true;
    }
    if (
      !!value.parent_ids.length &&
      !value.parent_ids.some((x) => !projectIds.includes(x))
    ) {
      return true;
    }
    return false;
  },
  applyBottomLevelParentId(values) {
    let bottomIterations = [];
    values.map((v) => {
      let bottomParentLevel = 99;
      let bottomParentId = null;
      let parents = valueHelpers.getParents({ value: v });
      if (!!parents.length) {
        let parentLevels = parents.map((p) => valueHelpers.getLevel(p));
        bottomParentLevel = Math.min(...parentLevels);
        // find first parent from values to leverage sortByTimeline
        let bottomParent = values.find(
          (p) =>
            v?.parent_ids.includes(p.id) &&
            valueHelpers.getLevel(p) == bottomParentLevel,
        );
        if (bottomParent) bottomParentId = bottomParent.id;
        else console.log("weird exception", bottomParentLevel, v);
      }

      let shouldAdd = false;
      let prevBottomIndex = bottomIterations.findIndex((b) => b.id == v.id);
      if (prevBottomIndex >= 0) {
        let prevBottom = bottomIterations[prevBottomIndex];
        // if(bottomParentLevel <= prevBottom.bottomParentLevel){
        // shouldAdd = true
        if (bottomParentLevel < prevBottom.bottomParentLevel) {
          shouldAdd = true;
          bottomIterations.splice(prevBottomIndex, 1);
        }
        // }
      } else {
        shouldAdd = true;
      }

      if (shouldAdd) {
        bottomIterations.push({
          bottomParentLevel,
          bottomParentId,
          id: v.id,
          // value: v,
        });
      }
    });

    values = values.map((v) => {
      let bottomParentLevel = 999;
      let bottomParentId = null;
      let bottomIteration = bottomIterations.find((i) => i.id == v.id);
      if (!!bottomIteration) {
        bottomParentLevel = bottomIteration.bottomParentLevel;
        bottomParentId = bottomIteration.bottomParentId;
      }
      return {
        ...v,
        bottomParentLevel,
        bottomParentId,
      };
    });
    return values;
  },
  getBottomLevelParent(value, values = null) {
    values = values || store.getState().values;

    let bottomParent = null;
    let bottomParentLevel = 99;
    for (let parent of valueHelpers.getParents({ value })) {
      let parentLevel = valueHelpers.getLevel(parent);
      if (parentLevel < bottomParentLevel) {
        bottomParentLevel = parentLevel;
        bottomParent = parent;
      }
    }
    let bottomParentId = bottomParent.id;

    return { bottomParentLevel, bottomParentId };
  },
  applyLevels(values) {
    return values.map((v) => {
      let level = valueHelpers.determineLevel(v, values);
      return {
        ...v,
        level,
      };
    });
  },
  determineLevel(value, values = []) {
    // if(!values) values = await storageActions.fetchItem('values', [])
    if (typeof value.id == "string" && value.id.includes("ftue_child"))
      return -1;
    if (!!value.ftue_item) return -1;
    if (typeof value.id == "string" && value.id.includes("ftue_parent"))
      return 1;
    let level = 0;
    let nextGenIds = value.child_ids;
    // let nextGen = values.filter(v => nextGenIds.includes(v.id) && !v.completed_at && !v.ftue_item)
    let nextGen = values.filter(
      (v) =>
        nextGenIds.includes(v.id) &&
        !valueHelpers.getCompletedAt(v) &&
        !v.ftue_item,
    );
    while (!!nextGen?.length) {
      level += 1;
      nextGenIds = nextGen.map((v) => v.child_ids).flat();
      nextGen = values.filter(
        (v) => nextGenIds.includes(v.id) && !valueHelpers.getCompletedAt(v),
      );
    }
    // console.log(level)
    return level;
  },
  familyColors(value, values) {
    let familyColors = [];
    let parentColors = [];
    let nextGenIds = value?.parent_ids || [];
    let nextGen = values.filter((v) => nextGenIds.includes(v.id));
    nextGen = textHelpers.newestFirst(nextGen, "updated_at");
    // let nextGen = values.filter(id: next_gen_ids).order(updated_at: :desc)
    while (!!nextGen?.length) {
      let nextGenColors = nextGen.map((v) => v.color).filter((v) => !!v);
      if (!parentColors.length) {
        parentColors = nextGenColors;
      }
      familyColors = familyColors.concat(nextGenColors);
      nextGenIds = nextGen.map((v) => v.parent_ids).flat();
      nextGen = values.filter((v) => nextGenIds.includes(v.id));
      nextGen = textHelpers.newestFirst(nextGen, "updated_at");
    }
    // value.parentColors = parentColors
    // value.familyColors = familyColors
    // return value
    return { familyColors, parentColors };
  },
  rootIcon(value, values, highest = false) {
    let rootIcon = value.icon;
    let nextGenIds = value.parent_ids;
    let nextGen = values.filter((v) => nextGenIds.includes(v.id));
    nextGen = textHelpers.newestFirst(nextGen, "updated_at");
    while (!!nextGen?.length) {
      let ancestorIcons = nextGen.map((v) => v.icon).filter((v) => !!v);
      let ancestorIcon = ancestorIcons.length ? ancestorIcons[0] : null;
      rootIcon = ancestorIcon || rootIcon;
      if (highest || !rootIcon) {
        nextGenIds = nextGen.map((v) => v.parent_ids).flat();
        nextGen = values.filter((v) => nextGenIds.includes(v.id));
        nextGen = textHelpers.newestFirst(nextGen, "updated_at");
      } else {
        nextGen = null;
      }
    }
    return { rootIcon };
  },
  children(root_id = null, all_revisions = false, value, values) {
    let children = values.filter((v) => value.child_ids?.includes(v.id));
    // children = Value.query(!all_revisions)
    //   .where('parent_ids @> ARRAY[?]::integer[]', self.id)
    //   .where.not(id: root_id)
    //   .order(root_id: :desc, created_at: :desc)
    return children;
  },
  parents(root_id = null, all_revisions = false, value, values) {
    let parents = values.filter((v) => value.parent_ids?.includes(v.id));
    // parents = Value.query(!all_revisions)
    //   .where(id: self.parent_ids)
    //   .where.not(id: root_id)
    //   .order(root_id: :desc, created_at: :desc)
    return parents;
  },
  revisions(adjacents = false, value, values) {
    // console.log(value, values)
    let revisions = values.filter(
      (v) => value.root_id == v.root_id && v.id != value.id,
    );
    return revisions;

    revisions = [value];
    let prev_revision = null;
    let next_revision = null;
    let revision_index = 0;
    // revisions = Value.query(false).where(root_id: self.root_id).order(root_id: :desc, created_at: :asc)
    // if adjacents
    //   prev_revision, next_revision, revision_index = nil
    //   revision_index = revisions.index self
    //   prev_revision = revision_index > 0 ? revisions[revision_index-1] : nil
    //   next_revision = revisions[revision_index+1]
    //   return prev_revision, next_revision, revision_index, revisions
    // else
    //   return revisions
    // end
    return { prev_revision, next_revision, revision_index, revisions };
  },
  timeline(recursive = true, condense = false, value, values) {
    // local timeline does not account for previous child revisions...
    if (!!value.timeline?.length && !ENV.DEMO) return value.timeline;
    return [];

    // if(!values) values = await storageActions.fetchItem('values', [])
    let bonus_types = [];
    let { prev_revision, next_revision, revision_index, revisions } =
      valueHelpers.revisions(true, value, values);

    let children_completions = [];
    if (recursive) {
      let completedAt = valueHelpers.getCompletedAt(value);
      valueHelpers
        .children(value.id, true, value, values)
        .forEach((child, i) => {
          let childTimeline = valueHelpers.timeline(
            recursive,
            condense,
            child,
            values,
          );
          childTimeline.forEach((event, j) => {
            if (
              prev_revision?.child_ids?.includes(child.id) &&
              event.timestamp < value.created_at
            ) {
              console.log(
                "skip #{child.id} and attribute this to previous revision",
              );
            }
            // else if(next_revision?.child_ids?.includes(child.id) && !!value.completed_at && event.timestamp > value.completed_at){
            else if (
              next_revision?.child_ids?.includes(child.id) &&
              !!completedAt &&
              event.timestamp > completedAt
            ) {
              console.log(
                "skip #{child.id} and attribute this to future revision",
              );
            } else if (event.type == "creation") {
              // # ignore
            } else if (["completion"].includes(event.type)) {
              event.type = "child_completion";
              let v = values.find((v) => v.id == event.id);
              event.type = "child_completion";
              // event.completed_at = v.completed_at
              event.completed_at = valueHelpers.getCompletedAt(v);
              // # event[:value] = v
              event.timeline = valueHelpers.timeline(false, false, v, values);
              children_completions.push(event);
            }
          });
        });
    }

    // let tz = 'Eastern Time (US & Canada)'

    // let progressions = value.progress_at.map(event => {
    //   return { timestamp: event, type: 'progress', text: value.text, id: value.id }
    // })

    let progressions = [];
    textHelpers.oldestFirst(value.progress_at || []).map((event, i) => {
      if (
        i == value.progress_at.count - 1 &&
        !!value.completed_at &&
        condense
      ) {
        // # skip last progression and condense into completion
        bonus_types.push("progress");
      }
      // else if(condense && event.in_time_zone(tz).to_date == value.created_at.in_time_zone(tz).to_date){
      else if (
        condense &&
        new Date(event).toDateString() ==
          new Date(value.created_at).toDateString()
      ) {
        // # skip and condense into creation
        bonus_types.push("progress");
      } else {
        let note = value.notes?.find((n) => n.text?.startsWith(i.toString()));
        progressions.push({
          timestamp: event,
          type: "progress",
          text: value.text,
          id: value.id,
          note,
        });
      }
    });

    let creations = [];
    if (prev_revision && prev_revision.text == value.text) {
      // # if !condense
      creations.push({
        timestamp: value.created_at,
        type: "extension",
        text: value.text,
        id: value.id,
        bonus_types: bonus_types,
      });
      bonus_types = [];
      // # end
    } else {
      if (
        condense &&
        !!value.progress_at?.length &&
        false
        // # self.progress_at.find { |pa| pa.in_time_zone(tz).to_date == self.created_at.in_time_zone(tz).to_date }
      ) {
        // # skip and condense into today's progression
        bonus_types.push("creation");
      } else {
        creations.push({
          timestamp: value.created_at,
          type: "creation",
          text: value.text,
          id: value.id,
        });
      }
    }

    let completions = [];
    // if(!!value.completed_at){
    if (!!valueHelpers.getCompletedAt(value)) {
      if (condense && next_revision) {
        // # skip and condense into next_revision's extension
        bonus_types.push("completion");
      } else {
        // let note = value.notes?.find((n) => n.text.startsWith("7"));
        let note = value.notes[0];
        completions.push({
          timestamp: value.completed_at,
          type: "completion",
          text: value.text,
          id: value.id,
          note,
        });
      }
    }

    let type_order = [
      "creation",
      "extension",
      "progress",
      "child_completion",
      "completion",
    ];
    let timeline = [
      ...children_completions,
      ...progressions,
      ...creations,
      ...completions,
    ];

    // begin
    // timeline = timeline.sort { |a,b|
    //   comp = a[:timestamp] <=> b[:timestamp]
    //   if comp == 0
    //     comp = (type_order.index a[:type]) <=> (type_order.index b[:type])
    //   end
    //   comp
    // }
    // rescue => e
    //   puts "ERROR!!!!!!!!"
    //   puts e
    // end

    // console.log(timeline)
    return timeline;
  },
  ancestorIds(value, values) {
    let ids = [];
    let parentIds =
      value.parent_ids ||
      (!!value.parents && value.parents.map((v) => v.id)) ||
      [];
    while (parentIds.length) {
      ids = [...ids, ...parentIds];
      let parents = values.filter((v) => parentIds.includes(v.id));
      parentIds = parents.map((v) => v.parent_ids).flat();
    }
    return ids;
  },
  descendantIds(value, values) {
    let ids = [];
    let childIds =
      value.child_ids ||
      (!!value.children && value.children.map((c) => c.id)) ||
      [];
    while (childIds.length) {
      ids = [...ids, ...childIds];
      let children = values.filter((v) => childIds.includes(v.id));
      childIds = children.map((v) => v.child_ids).flat();
    }
    return ids;
  },

  getCompletedAt(value, orLastProgressAt = false) {
    if (!value?.completed_at && !value?.completed_at && !orLastProgressAt) {
      return null;
    } else {
      let ts = value.completed_at || value.created_at;
      if (!!value.progress_at?.length) {
        let lastProgressAt = [...value.progress_at].sort()[
          value.progress_at.length - 1
        ];
        ts = lastProgressAt;
      }
      return ts;
    }
  },
  getTimestamp({
    value,
    inheritProgress = true,
    inheritGrandchildren = null,
    returnValue = false,
    acceptCreatedAt = true,
    recurring = false,
  }) {
    let timestamp = value.created_at;
    let progressedValue = value;
    // if (inheritGrandchildren !== null || !acceptCreatedAt) timestamp = null; // do not accept created_at from children
    if (!acceptCreatedAt) timestamp = null; // do not accept created_at from children
    let completedAt = valueHelpers.getCompletedAt(value);
    if (!!completedAt) timestamp = completedAt;
    else {
      if (!inheritProgress) {
        // only check direct progress
        let progressions = valueHelpers.getProgressions({
          value,
          inherit: false,
        });
        let lastProgression = progressions[progressions.length - 1];
        if (!!lastProgression?.timestamp) {
          timestamp = lastProgression.timestamp;
        }
      } else {
        // check progress from child completions
        let progressions = valueHelpers.getProgressions({ value });
        let lastProgression = progressions[progressions.length - 1];
        if (!!lastProgression?.timestamp) {
          // if(!!lastProgression?.timestamp && (!timestamp || lastProgression.timestamp > timestamp)){
          // timestamp can only be created_at, but we never want that instead of progress
          timestamp = lastProgression.timestamp;
        }

        // check inherited children progress only if cycle == 0
        // if(!recurring){ // top level
        if (!recurring && inheritGrandchildren === null) {
          // top level
          // if (value.cycle === 0) inheritGrandchildren = true;
          // else inheritGrandchildren = false;
          inheritGrandchildren = false;
        }
        if (!recurring || inheritGrandchildren) {
          valueHelpers
            .getChildren({ value, includeNotes: true })
            .forEach((child) => {
              let ts = valueHelpers.getTimestamp({
                value: child,
                inheritProgress: true,
                inheritGrandchildren,
                returnValue,
                recurring: true,
              });
              let childTs = returnValue ? ts.timestamp : ts;
              if (!!childTs && (!timestamp || childTs > timestamp)) {
                timestamp = childTs;
                progressedValue = returnValue ? ts.value : child;
              }
            });
        }
      }
    }
    if (returnValue) {
      return { timestamp, value: progressedValue };
    }
    return timestamp;
  },
  getProgressions({
    value,
    filteredValueIds = [],
    includePastRevisions = false,
    includeEmpties = false,
    range = {},
    inherit = true, // inherit progress from children completions
    condense = false, // group completions by root_id
    timeline = false, // include empty day spaces
  }) {
    let progressions = [];
    if (inherit) {
      if (valueHelpers.isReference(value)) {
        let refValue = valueHelpers.getRefValue(value);
        progressions = valueHelpers.getPropagatedProgressions({
          value: refValue,
          // includePastRevisions,
          includePastRevisions: false,
          // includeEmpties,
          includeEmpties: false,
          range: { startAt: value.created_at },
        });
        // let cycle = value.cycle || ENV.CYCLE
        // progressions = progressions.slice(0, cycle)
        // console.log(progressions[0].timestamp, value.created_at, timeHelpers.withinRange(progressions[0].timestamp, {startAt: value.created_at}))
        progressions = progressions.filter((p) =>
          timeHelpers.withinRange(p.timestamp, { startAt: value.created_at }),
        );
        progressions = progressions.reverse();
        // console.log('ref value progressions:', progressions.length, value.created_at)
        return progressions;
      }

      let { endAt, startAt } = range;

      let pastRevisions = valueHelpers.getPastRevisions(value);
      if (includePastRevisions) {
        pastRevisions.forEach((rev) => {
          // progressions = [...progressions, ...valueHelpers.getProgressions({value: rev, filteredValueIds})]
          progressions = [
            ...progressions,
            ...valueHelpers.getProgressions({
              value: rev,
              filteredValueIds,
              range,
              timeline,
            }),
          ];
        });
      }

      let children = valueHelpers.getChildren({
        value,
        includePreviousRevisions: true,
      });
      if (!!filteredValueIds.length) {
        children = children.filter((c) => filteredValueIds.includes(c.id));
      }

      // no infinite child notches
      // children = children.filter((c) => !valueHelpers.isInfinite(c));
      // no infinite child notches (unless complete?)
      children = children.filter(
        (c) => !valueHelpers.isInfinite(c) || c.completed,
      );

      if (!!children.length) {
        let completedChildren = children;
        if (!timeline) {
          completedChildren = children.filter(
            (v) => !!valueHelpers.getCompletedAt(v, timeline),
          );
        }

        // what problem does this solve?
        // children completions should be removed if they were attributed to a previous revision?
        // can that be determined by checking if they the child was completed before this value was created?

        if (!!pastRevisions.length) {
          let previousRevision = pastRevisions[pastRevisions.length - 1];
          let previousRevisionComletedAt = valueHelpers.getCompletedAt(
            previousRevision,
            timeline,
          );
          if (!!previousRevisionComletedAt) {
            completedChildren = completedChildren.filter((c) => {
              let childCompletedAt = valueHelpers.getCompletedAt(c, timeline);
              if (!c.parent_ids.includes(previousRevision.id)) {
                return true;
              } else if (childCompletedAt > value.created_at) {
                return true;
              } else if (childCompletedAt > previousRevisionComletedAt) {
                return true;
              }
              return false;
            });
          }
        }

        completedChildren = completedChildren.map((c) => ({
          ...c,
          completed_at: valueHelpers.getCompletedAt(c, timeline),
        }));
        completedChildren = textHelpers.newestFirst(
          completedChildren,
          "completed_at",
        );

        completedChildren.forEach((child) => {
          // let childCompletedAt = valueHelpers.getCompletedAt(child);
          let childCompletedAt = child.completed_at;
          if (!!child.progress_at?.length) {
            let lastP = child.progress_at[child.progress_at.length - 1];
            if (!childCompletedAt || lastP > childCompletedAt)
              childCompletedAt = lastP;
          }
          if (timeHelpers.withinRange(childCompletedAt, range)) {
            let condensedProgression = null;
            if (condense) {
              condensedProgression = progressions.find(
                (p) => p.type == "completion" && p.root_id == child.root_id,
              );
            }
            if (!!condensedProgression) {
              condensedProgression.iterations =
                !!condensedProgression.iterations
                  ? condensedProgression.iterations + 1
                  : 2;
            } else {
              progressions.push({
                ...child,
                uid: `${child.id}_completion`,
                timestamp: childCompletedAt,
                type: "completion",
                iterations: 0,
              });
            }
          }
        });
      }
    } // end inherit

    let color = valueHelpers.getColor(value);
    let icon = valueHelpers.getIcon(value);
    value.progress_at?.forEach((p, i) => {
      if (value.id == 718) {
        // console.log('chekcing: ', p, range, timeHelpers.withinRange(p, range))
      }
      if (timeHelpers.withinRange(p, range)) {
        let text = "✓";
        if (!!value.notes?.length) {
          // let note = value.notes.find((n) => n.text.startsWith(i + 1));
          let note = value.notes[i];
          // if (!!note) text = note.split(":")[1];
        }
        progressions.push({
          id: `progress_${value.id}`,
          uid: `${value.id}_progress_${new Date(p).getTime()}`,
          type: "progress",
          parent: value,
          timestamp: p,
          completed_at: p,
          progress_at: [],
          value_id: value.id,
          parent_ids: [value.id],
          text,
          color,
          icon,
        });
      }
    });

    if (!!value?.moments?.length) {
      value.moments.forEach((m, i) => {
        if (!!m.completed_at) {
          progressions.push({
            id: `moment_${m.id}`,
            uid: `${value.id}_moment_${m.id}_${i}`,
            type: "progress",
            paernt: value,
            timestamp: m.completed_at || m.updated_at,
            completed_at: m.completed_at || m.updated_at,
            progress_at: [],
            value_id: value.id,
            parent_ids: [value.id],
            text,
            color,
            icon,
          });
        }
      });
    }

    let completedAt = valueHelpers.getCompletedAt(value);
    if (!!completedAt && !progressions.length) {
      // if(timeHelpers.withinRange(completedAt, range)){
      progressions.push({
        ...value,
        notes: [],
        text: "✓",
        id: `${value.id}_completion`,
        // uid: `${value.id}_completion_${new Date(value.completed_at).getTime()}`,
        uid: `${value.id}_completion_${new Date(
          valueHelpers.getCompletedAt(value),
        ).getTime()}`,
        type: "completion",
        timestamp: completedAt,
        // timestamp: value.completed_at,
        // completed_at: value.completed_at,
        // progress_at: [],
        // value_id: value.id,
        // parent_ids: [value.parent_ids],
        // text: value.text,
        // color,
        // icon,
      });
    }

    // includeEmpties means include snoozed children and self's created_at
    if (includeEmpties) {
      // snoozed self
      let dueIn = frequencyHelpers.getDueIn(value);
      if (dueIn !== null && dueIn <= 0) {
        let dueStatus = null;
        if (dueIn == 0) {
          dueStatus = frequencyHelpers.getStatus(dueIn, value);
        }
        if (dueStatus != "done") {
          let dueTs = frequencyHelpers.getDueTimestamp(dueIn);
          progressions.push({
            ...value,
            id: `${value.id}_due`,
            uid: `${value.id}_due_${dueTs}`,
            type: "due",
            timestamp: dueTs,
          });
        }
      }

      // if(value.snooze_until){
      //   // if(!endAt || endAt > new Date(value.snooze_until).getTime()){
      //   let snoozeTs = new Date(value.snooze_until).getTime()
      //   if(snoozeTs < endAt && snoozeTs > startAt){
      //     progressions.push({
      //       ...value,
      //       id: `${value.id}_snooze`,
      //       uid: `${value.id}_snooze_${snoozeTs}`,
      //       type: 'snooze',
      //       timestamp: value.snooze_until,
      //     })
      //   }
      // }

      // snoozed children
      let snoozedChildren = children.filter(
        (c) => !c.completed_at && !!c.snooze_until,
      );
      snoozedChildren.forEach((child) => {
        let snoozeTs = new Date(child.snooze_until).getTime();
        if (timeHelpers.withinRange(snoozeTs, range)) {
          // if(!endAt || endAt > new Date(child.snooze_until).getTime()){
          progressions.push({
            ...child,
            id: `${child.id}_snooze`,
            uid: `${child.id}_snooze_${snoozeTs}`,
            type: "snooze",
            timestamp: child.snooze_until,
          });
        }
      });

      // created_at
      if (!progressions.length) {
        let creationTs = new Date(value.created_at).getTime();
        if (timeHelpers.withinRange(creationTs, range)) {
          // if((!endAt || creationTs < endAt) && (!startAt || creationTs > startAt)){
          console.log("-------------", value);
          progressions.push({
            ...value,
            id: `${value.id}_creation`,
            uid: `${value.id}_creation_${creationTs}`,
            type: "creation",
            timestamp: value.created_at,
            text: "Created",
          });
        }
      }
    }

    // add empty timeline days
    if (timeline) {
      let timelineRange = value.frequency || 7;
      let timelineProgressions = [];
      let today = timeHelpers.beginningOfDay();
      let oldestDay = timeHelpers.daysFromNow(-timelineRange);
      while (timeHelpers.isAfter(today, oldestDay)) {
        timelineProgressions.push({
          timestamp: today,
          progressions: [],
          id: `${today.getTime()}_aggergation`,
          uid: `${value.id}_aggregation_${today.getTime()}`,
          type: "aggergation",
          text: "",
          color: colors.empty,
        });
        today = timeHelpers.daysFromNow(-1, today);
      }

      progressions = textHelpers.newestFirst(progressions, "timestamp");
      // console.log("BEGIN!", value.text, timelineProgressions, progressions);
      for (let d of timelineProgressions) {
        let day = d.timestamp;
        // console.log("--checking day", day);
        for (let p of progressions) {
          // console.log("----checking progression", p.timestamp);
          if (timeHelpers.isBefore(timeHelpers.endOfDay(day), p.timestamp)) {
            // console.log("------continue to the next progression");
            // continue to the next progression
            continue;
          } else if (timeHelpers.isAfter(day, p.timestamp)) {
            // console.log("------move on to next day");
            // move on to the next day
            break;
          }
          d.progressions = [...d.progressions, p];
          // console.log("------this progression was today!", d.progressions);
        }
      }
      for (let d of timelineProgressions) {
        let pColors = d.progressions.map((p) => valueHelpers.getColor(p));
        pColors = pColors.filter((c) => !!c);
        if (!!pColors?.length) {
          d.color = colorHelpers.averageColor(pColors);
        } else {
          d.color = colors.fill;
        }
      }
      // console.log("TIMELINE", value.text, timelineProgressions);

      progressions = timelineProgressions;
    }

    // progressions = textHelpers.oldestFirst(progressions, 'completed_at', 'updated_at')
    progressions = textHelpers.oldestFirst(progressions, "timestamp");
    progressions = progressions.map((p, i) =>
      p.text == "✓" ? { ...p, text: `${i + 1}` } : p,
    );
    return progressions;
  },
  getPropagatedProgressions({
    value,
    includePastRevisions = true,
    includeEmpties = false,
    range = { startAt: null, endAt: null },
    chunk = "day",
    moments = [],
  }) {
    let progressions = valueHelpers.getProgressions({
      value,
      includePastRevisions,
      includeEmpties,
      range,
    });
    valueHelpers.getDescendants(value, true).forEach((v) => {
      // progressions = [...progressions, ...valueHelpers.getProgressions({value: v, range})]
      progressions = [
        ...progressions,
        ...valueHelpers.getProgressions({
          value: v,
          includePastRevisions,
          includeEmpties,
          range,
        }),
      ];
    });
    valueHelpers.getPastRevisions(value).forEach((v) => {
      // progressions = [...progressions, ...valueHelpers.getProgressions({value: v, range})]
      progressions = [
        ...progressions,
        ...valueHelpers.getProgressions({
          value: v,
          includePastRevisions,
          includeEmpties,
          range,
        }),
      ];
    });
    progressions = textHelpers.uniq(progressions, "uid");
    progressions = textHelpers.newestFirst(progressions, "timestamp");
    progressions = valueHelpers.condenseProgressions(progressions, chunk);
    return progressions;
  },
  condenseProgressions(progressions, chunkBy = "day") {
    // return only the most recent progression from each day
    let allProgressions = [...progressions];
    return progressions
      .map((event) => {
        let dt = new Date(event.timestamp);
        let D = dt.getDate();
        let M = dt.getMonth();
        let Y = dt.getYear();
        let W = timeHelpers.getWeek(dt);
        let eventsByChunk = allProgressions.filter((p) => {
          // if(p.uiq == event.uid) return false
          let pdt = new Date(p.timestamp);
          let isSameChunk = false;
          if (chunkBy == "day") {
            isSameChunk =
              pdt.getDate() == D && pdt.getMonth() == M && pdt.getYear() == Y;
          } else if (chunkBy == "week") {
            isSameChunk = timeHelpers.getWeek(pdt) == W && pdt.getYear() == Y;
          } else if (chunkBy == "month") {
            isSameChunk = pdt.getMonth() == M && pdt.getYear() == Y;
          }
          return isSameChunk;
        });
        // eventsByChunk = textHelpers.newestFirst(eventsByChunk, 'timestamp')
        // if(eventsByChunk[eventsByChunk.length-1].uid == event.uid){
        if (eventsByChunk[0].uid == event.uid) {
          return {
            ...event,
            condensed: eventsByChunk.filter((e) => e.uid != event.uid),
          };
        } else {
          return null;
        }
      })
      .filter((x) => !!x);
  },
  getRevisions(value, includeSelf = false, valueSet = null) {
    // pass valueSet through to select most recent revision from set of options
    let values = valueSet || store.getState().values;
    let revisions = values.filter(
      (v) => !!value?.root_id && v.root_id == value.root_id,
    );
    if (!includeSelf) revisions = revisions.filter((v) => v.id !== value?.id);
    revisions = textHelpers.oldestFirst(revisions, "created_at");
    return revisions;
  },
  getCurrentRevision(value, valueSet) {
    // console.log(value);
    let revisions = valueHelpers.getRevisions(value, true, valueSet);
    revisions = textHelpers.newestFirst(revisions, "created_at");
    let incompleteRevisions = revisions
      .filter((r) => !r.completed_at && !r.archived_at)
      .reverse();
    if (!!incompleteRevisions.length) {
      // get first oldest incomplete revision
      let firstIncomplete = incompleteRevisions.find(
        (r) => !r.completed_at && !r.archived_at,
      );
      if (firstIncomplete) return firstIncomplete;
      // incompleteRevisions.forEach(r => {
      //   if(firstIncomplete) console.log('errrorrrr', firstIncomplete)
      //   if(!r.completed){
      //     firstIncomplete = r
      //     return r
      //   }
      // })
      // if(firstIncomplete) return firstIncomplete
    }
    return revisions[0] || value;
  },
  getPastRevisions(value) {
    let revisions = valueHelpers.getRevisions(value);
    let pastRevisions = revisions.filter(
      (v) => v.created_at < value.created_at,
    );
    return pastRevisions;
  },
  getFutureRevisions(value) {
    let revisions = valueHelpers.getRevisions(value);
    let futureRevisions = revisions.filter(
      (v) => v.created_at > value.created_at,
    );
    return futureRevisions;
  },
  filterToCurrentRevisions(values, valueSet = null) {
    // pass valueSet through to select most recent revision from set of options
    let currentRevisions = values
      .map((v) => {
        let currentRevision = valueHelpers.getCurrentRevision(v, valueSet);
        if (v.id == currentRevision.id) {
          return v;
        } else return null;
      })
      .filter((v) => v != null);
    return currentRevisions;
  },
  getFamily(value) {
    let ancestors = valueHelpers.getAncestors(value);
    let descendants = valueHelpers.getDescendants(value);
    let family = [value, ...ancestors, ...descendants];
    return family;
  },
  getAncestors(value) {
    let ancestors = [];
    let parents = valueHelpers.getParents({ value });
    while (!!parents.length) {
      ancestors = [...ancestors, ...parents];
      let nextGen = [];
      parents.forEach((v) => {
        nextGen = [...nextGen, ...valueHelpers.getParents({ v })];
      });
      parents = nextGen;
    }
    return ancestors;
  },
  getDescendants(value, includePreviousRevisions = false) {
    let descendants = [];
    let children = valueHelpers.getChildren({
      value,
      includePreviousRevisions,
    });
    while (!!children.length) {
      descendants = [...descendants, ...children];
      let nextGen = [];
      children.forEach((v) => {
        nextGen = [
          ...nextGen,
          ...valueHelpers.getChildren({ value: v, includePreviousRevisions }),
        ];
      });
      children = nextGen;
    }
    return descendants;
  },
  getTimeline(value, recursive = false, iterations = 0, range = {}, opts = {}) {
    // events are formatted as: { event_id, value, category, timestamp }
    let values = store.getState().values;
    let children = valueHelpers.getChildren({
      value,
      sort: true,
      includeNotes: true,
    });
    let icon = valueHelpers.getIcon(value);
    let color = valueHelpers.getColor(value);
    let timeline = [];

    if (!!value.created_at) {
      timeline.push({
        category: "creation",
        event_id: `${value.id}-creation`,
        timestamp: value.created_at,
        value: {
          ...value,
          completed_at: null,
          percent: 0,
        },
      });
    }

    if (
      !(value.progress_at?.length == 1 && !!value.completed_at) &&
      !!value?.progress_at?.length
    ) {
      value.progress_at.forEach((p, i) =>
        timeline.push({
          category: "progress",
          event_id: `${value.id}-progress-${i}`,
          timestamp: p,
          value,
        }),
      );
    }

    let moments = value?.moments;
    if (!!moments?.length) {
      moments.forEach((m, i) =>
        timeline.push({
          category: "progress",
          event_id: `${value.id}-moment-${i}`,
          timestamp: m.completed_at || m.created_at,
          // an uncompleted pin only marks intent, not actual progress
          pin: !m.completed_at,
          // carry the moment itself so hovers can show its story text
          moment: m,
          value,
        }),
      );
    }

    // if (!!value.completed_at && !value.is_note) {
    if (!!value.completed_at) {
      timeline.push({
        category: "completion",
        event_id: `${value.id}-completion`,
        timestamp: value.completed_at,
        value,
      });
    }

    if (!!value.archived_at) {
      timeline.push({
        category: "archive",
        event_id: `${value.id}-archive`,
        timestamp: value.archived_at,
        value,
      });
    }

    children.forEach((child) => {
      if (recursive) {
        let childTimeline = valueHelpers.getTimeline(
          child,
          recursive,
          iterations + 1,
          {},
          opts,
        );
        if (!opts.includeChildCreations) {
          childTimeline = childTimeline.filter(
            (e) => e.category != "creation",
          );
        }
        timeline = [...timeline, ...childTimeline];
      } else {
        // notes already appear as a "note" event at created_at
        if (opts.includeChildCreations && !!child.created_at && !child.is_note) {
          timeline.push({
            category: "creation",
            event_id: `${child.id}-creation`,
            timestamp: child.created_at,
            value: {
              ...child,
              completed_at: null,
              percent: 0,
            },
          });
        }
        if (child.is_note) {
          timeline.push({
            category: "note",
            event_id: `${child.id}-note`,
            timestamp: child.created_at,
            value: child,
          });
        }
        if (!!child.completed_at && !child.is_note) {
          timeline.push({
            category: "completion",
            event_id: `${child.id}-completion`,
            timestamp: child.completed_at,
            value: child,
          });
        }
        let icon = valueHelpers.getIcon(child);
        let color = valueHelpers.getColor(child);
        if (!(child.progress_at?.length == 1 && !!child.completed_at)) {
          child.progress_at.forEach((p, i) =>
            timeline.push({
              category: "progress",
              event_id: `${child.id}-progress-${i}`,
              timestamp: p,
              value: child,
              // icon,
              // color,
              // created_at: p,
              // completed_at: p,
              // timestamp: p,
              // is_progress: true,
              // value_id: child.id,
              // text: `${child.text}`,
            }),
          );
        }
      }
    });
    // if (iterations == 0) console.log("top", timeline.length);
    // timeline = textHelpers.uniq(timeline, "id");
    timeline = textHelpers.oldestFirst(timeline, "timestamp");
    // timeline = timeline.sort((a, b) => {
    //   let tsA = Math.max(
    //     a.created_at ? new Date(a.created_at).getTime() : 0,
    //     a.completed_at ? new Date(a.completed_at).getTime() : 0
    //   );
    //   let tsB = Math.max(
    //     b.created_at ? new Date(b.created_at).getTime() : 0,
    //     b.completed_at ? new Date(b.completed_at).getTime() : 0
    //   );
    //   return tsA > tsB ? 1 : -1;
    // });
    if (value.id == 4926) {
      console.log(range, timeline);
    }
    if (!!range?.startAt && !!range?.endAt) {
      timeline = timeline.filter(
        (e) =>
          new Date(e.timestamp) >= range.startAt &&
          new Date(e.timestamp) <= range.endAt,
      );
    }
    return timeline;
  },
  getNotes(value = {}, filterToActive = false, sortByIds = true) {
    let values = store.getState().values;
    let notes = values.filter((v) => value.note_ids?.includes(v.id));

    // if (filterToActive)
    //   parents = parents.filter((p) => !valueHelpers.getCompletedAt(p));

    // if (sortByIds && !!value.parent_ids) {
    //   let order = {};
    //   value.parent_ids?.forEach((id, i) => {
    //     order[id] = i;
    //   });
    //   parents.sort((a, b) => {
    //     return order[a.id] - order[b.id];
    //   });
    // } else parents = textHelpers.oldestFirst(parents, "root_id");

    return notes;
  },
  getChildren({
    value = {},
    includePreviousRevisions = true,
    sort = false,
    includeNotes = false,
    values = null,
  }) {
    // // getParents(value = {}, filterToActive = false, sortByIds = true) {
    //   let values = store.getState().values;
    //   let children = values.filter((v) => value.child_ids?.includes(v.id));

    //   if (filterToActive)
    //     parents = parents.filter((p) => !valueHelpers.getCompletedAt(p));

    values = values || store.getState().values;
    let valueId = value.id;
    if (valueHelpers.isReference(value)) {
      let refValue = valueHelpers.getRefValue(value);
      if (!!refValue?.id) valueId = refValue.id;
    }
    let children = [];
    if (false && !!value.children?.length) {
      children = value.children;
    } else {
      // children = values.filter((v) => v.parent_ids?.includes(valueId));
      // Set lookup — .includes inside the filter made this O(store × child_ids)
      let childIdSet = new Set(value.child_ids || []);
      children = values.filter((v) => childIdSet.has(v.id));
    }
    if (!includeNotes) children = children.filter((c) => !c.is_note);
    else {
      // children = [...children, ...valueHelpers.getNotes(value)];
      // children = children = children.filter((c) => !!c.is_note);
    }

    // this should happen server side
    if (!includePreviousRevisions) {
      children = valueHelpers.filterToCurrentRevisions(children, children);
    }

    if (sort == "list") {
      children = [
        ...children.sort((a, b) => {
          let tsA = Math.max(
            // a.completed_at ? new Date(a.completed_at).getTime() : 0,
            !!a.progress_at?.length
              ? new Date(a.progress_at[a.progress_at.length - 1]).getTime()
              : 0,
            a.created_at ? new Date(a.created_at).getTime() : 0,
            a.archived_at ? new Date(a.archived_at).getTime() : 0,
          );
          let tsB = Math.max(
            // b.completed_at ? new Date(b.completed_at).getTime() : 0,
            !!b.progress_at?.length
              ? new Date(b.progress_at[b.progress_at.length - 1]).getTime()
              : 0,
            b.created_at ? new Date(b.created_at).getTime() : 0,
            b.archived_at ? new Date(b.archived_at).getTime() : 0,
          );
          return tsA > tsB ? 1 : -1;
        }),
      ];
    } else if (sort == "inherited") {
      children = [
        ...children.sort((a, b) => {
          return a.inherited_timestamp < b.inherited_timestamp ? 1 : -1;
        }),
      ];
      // children = children.map((c) => ({
      //   ...c,
      //   timestamp: valueHelpers.getTimestamp({
      //     value: c,
      //     inheritGrandchildren: true,
      //   }),
      // }));
      // children = [
      //   ...children.sort((a, b) => {
      //     return a.timestamp < b.timestamp ? 1 : -1;
      //   }),
      // ];
    } else if (sort) {
      children = [
        ...children.sort((a, b) => {
          let aCompletion = valueHelpers.getCompletedAt(a);
          let bCompletion = valueHelpers.getCompletedAt(b);

          // push archived items to the front
          if (!!a.archived_at && !b.archived_at) return -1;
          else if (!!b.archived_at && !a.archived_at) return 1;
          else if (!!a.archived_at && !!b.archived_at) {
            return a.archived_at > b.archived_at;
          }

          // push completed items to the front
          if (!!aCompletion && !bCompletion) return -1;
          else if (!!bCompletion && !aCompletion) return 1;

          let compA =
            valueHelpers.getCompletedAt(a) ||
            (includeNotes ? a.created_at : a.updated_at);
          let compB =
            valueHelpers.getCompletedAt(b) ||
            (includeNotes ? b.created_at : b.updated_at);
          return compA > compB ? 1 : -1;
        }),
      ];
    } else {
      children = textHelpers.sortByIds(value.child_ids, children);
    }

    return children;
  },
  hasGrandChildren(value) {
    let grandChildrenIds = [];
    let children = valueHelpers.getChildren({ value });
    for (let child of children) {
      if (!!child.child_ids?.length) return true;
      // let grandChildren = valueHelpers.getChildren({value: child})
      grandChildrenIds = [...grandChildrenIds, ...child.child_ids];
    }
    grandChildrenIds = textHelpers.uniq(grandChildrenIds);
    return !!grandChildrenIds?.length;
  },
  getParents({
    value = {},
    filterToActive = false,
    sortByIds = true,
    includePreviousRevisions = true,
    values = null,
  }) {
    values = values || store.getState().values;
    let parentIdSet = new Set(value.parent_ids || []);
    let parents = values.filter((v) => parentIdSet.has(v.id));
    // console.log(`value ${value.id} parents:`, parents, values);

    // this should happen server side now
    // parents = valueHelpers.filterToCurrentRevisions(parents, parents);

    if (filterToActive)
      parents = parents.filter((p) => !valueHelpers.getCompletedAt(p));

    if (!includePreviousRevisions) {
      parents = valueHelpers.filterToCurrentRevisions(parents, parents);
    }

    if (sortByIds && !!value.parent_ids) {
      let order = {};
      value.parent_ids?.forEach((id, i) => {
        order[id] = i;
      });
      parents.sort((a, b) => {
        return order[a.id] - order[b.id];
      });
    } else parents = textHelpers.oldestFirst(parents, "root_id");

    return parents;
  },
  getIcon(value, closest = true) {
    let icon = null;
    if (!!value?.icon || !!value?.inherited_icon) {
      icon = value?.icon || value?.inherited_icon;
    }
    if (!icon || !closest) {
      for (let parent of valueHelpers.getParents({ value })) {
        let parentIcon = valueHelpers.getIcon(parent, closest);
        if (!!parentIcon) {
          icon = parentIcon;
          if (closest) {
            break;
          }
        }
      }
    }
    return icon;
  },
  getColor(value = {}, colorScheme, fallback = colors.trim) {
    let color = fallback;
    if (!value) return color;
    if (
      (false && !value.id) ||
      (typeof value.id == "string" && value.id.includes("ftue"))
    ) {
      color = colors.empty;
    } else if (!!value.color || !!value.inherited_color) {
      color = value.color || value.inherited_color;
      if (color.startsWith("#")) {
        color = color;
      } else {
        color = valueHelpers.colorAsHex(color, colorScheme);
      }
    } else if (valueHelpers.isReference(value)) {
      let refValue = valueHelpers.getRefValue(value);
      color = valueHelpers.getColor(refValue);
    } else {
      let parents = valueHelpers.getParents({ value });
      let parentColors = parents.map((p) => valueHelpers.getColor(p));
      parentColors = parentColors.filter((p) => !!p);
      if (!!parentColors.length) {
        color = colorHelpers.averageColor(parentColors);
      }
    }
    // console.log(value, color)
    return color;
  },
  wasProgressedToday(value, dateCutoff = null, returnTimestamp = false) {
    let datetimeCutoff = null;
    if (dateCutoff) {
      datetimeCutoff = new Date(dateCutoff);
      datetimeCutoff.setHours(23, 59, 59, 0);
    }
    // let timestamp = valueHelpers.getPropagatedUpdatedAt({value, recursive: false, datetimeCutoff})
    let progressions = valueHelpers.getProgressions({ value });
    // let timestamp = progressions[0]?.timestamp;
    let wasProgressedToday = false;
    let ts = null;

    for (let p of progressions) {
      if (!!p?.timestamp) {
        let wasToday = timeHelpers.wasToday(p.timestamp);
        if (wasToday) {
          if (value?.title?.includes("Prompt Sh")) {
            console.log(wasToday, p.timestamp);
          }
          wasProgressedToday = true;
          ts = p.timestamp;
          break;
        }
      }
    }

    if (returnTimestamp) {
      return [wasProgressedToday ? 1 : 0, ts];
    }
    return wasProgressedToday ? 1 : 0;
  },
  getPropagatedUpdatedAt({
    value,
    includeCreatedAt = false,
    datetimeCutoff = null,
    recursive = true,
    checkChildren = true,
    includePreviousRevisions = true,
  }) {
    // let datetime = store.getState().app.datetime
    let timestamp = includeCreatedAt ? value.created_at : null;
    // if(value.id==468) console.log('1: ', timestamp)
    // let otherTs = [value.completed_at].filter(x => !!x).sort().reverse()
    let otherTs = [valueHelpers.getCompletedAt(value)]
      .filter((x) => !!x)
      .sort()
      .reverse();
    // let otherTs = [value.completed_at, value.updated_at].filter(x => !!x).sort().reverse()

    if (includePreviousRevisions) {
      let pastRevisionTs = [];
      let revisions = valueHelpers.getPastRevisions(value);
      revisions.forEach((r) => {
        let rts = valueHelpers.getPropagatedUpdatedAt({
          value: r,
          includeCreatedAt,
          datetimeCutoff,
          checkChildren: recursive,
          includePreviousRevisions: false,
        });
        // if(rts.startsWith("2021-05-15")){
        //   if(value.id=468) console.log(r, rts)
        // }
        pastRevisionTs.push(rts);
      });
      otherTs = [...otherTs, ...pastRevisionTs]
        .filter((x) => !!x)
        .sort()
        .reverse();
    }

    if (!!datetimeCutoff)
      otherTs = otherTs.filter((ts) => new Date(ts).getTime() < datetimeCutoff);
    // if(value.id==10) console.log(otherTs, timestamp)
    for (let ts of otherTs) {
      // console.log(ts, '>', timestamp, (ts > timestamp))
      if (!timestamp || ts > timestamp) {
        timestamp = ts;
        // if(value.id==468) console.log('2: ', timestamp)
        break;
      }
    }
    // if(value.id==10) console.log(timestamp)

    if (!!value.progress_at?.length) {
      let progressAt = [...value.progress_at].sort().reverse();
      if (!!datetimeCutoff)
        progressAt = progressAt.filter(
          (ts) => new Date(ts).getTime() < datetimeCutoff,
        );
      let lastProgressAt = progressAt[0];
      if (!timestamp || lastProgressAt > timestamp) {
        // if(value.id==468) console.log('lastPAt', lastProgressAt)
        timestamp = lastProgressAt;
        // if(value.id==468) console.log('3: ', timestamp)
      }
    }

    // if(!checkChildren) return timestamp

    // let children = valueHelpers.getChildren({value, includePreviousRevisions})
    let children = valueHelpers.getChildren({
      value,
      includePreviousRevisions: true,
    });
    if (children.length) {
      let childrenTimestamps = children.map((child) => {
        if (value.id == 468) {
          // console.log(value.text, child.id, child.text, valueHelpers.getPropagatedUpdatedAt({value: child, includeCreatedAt, datetimeCutoff, checkChildren: recursive, includePreviousRevisions}))
          // if(!valueHelpers.getPropagatedUpdatedAt({value: child, includeCreatedAt, datetimeCutoff, checkChildren: recursive, includePreviousRevisions})){
          //   console.log({value: child, includeCreatedAt, datetimeCutoff, checkChildren: recursive, includePreviousRevisions})
          // }
        }
        return valueHelpers.getPropagatedUpdatedAt({
          value: child,
          includeCreatedAt,
          datetimeCutoff,
          checkChildren: recursive,
          includePreviousRevisions,
        });
      });
      childrenTimestamps = childrenTimestamps.filter((x) => !!x);
      if (!!datetimeCutoff)
        childrenTimestamps = childrenTimestamps.filter(
          (ts) => new Date(ts).getTime() < datetimeCutoff,
        );
      let newestChildTimestamp = childrenTimestamps.sort().reverse()[0];
      // if(value.id==468) console.log('newest:', newestChildTimestamp)
      if (!timestamp || newestChildTimestamp > timestamp) {
        timestamp = newestChildTimestamp;
        // if(value.id==468) console.log('4: ', timestamp)
      } else {
        // if(value.id==468) console.log('nope?:', timestamp, newestChildTimestamp)
      }
    }
    // if(value.id==468) console.log('final: ', value.text, timestamp)
    return timestamp;
  },
  sortByProgress(values, levelIds) {
    let sortedValues = [];
    Object.keys(levelIds).forEach((level) => {
      let levelValues = values.filter((v) => levelIds[level].includes(v.id));
      let timestampedValues = levelValues.map((v) => ({
        ...v,
        timestamp: valueHelpers.getPropagatedUpdatedAt({
          value: v,
          includeCreatedAt: true,
        }),
      }));
      let sortedLevelValues = textHelpers.newestFirst(
        timestampedValues,
        "timestamp",
        "updated_at",
      );
      sortedValues = [...sortedValues, ...sortedLevelValues];
    });
    return sortedValues;
  },
  isSnoozed(value = {}) {
    if (!value.snooze_until) return false;
    if (!!valueHelpers.getCompletedAt(value)) return false;
    let now = new Date().getTime();
    let snoozeUntil = new Date(value.snooze_until).getTime();
    return snoozeUntil > now;
  },
  isDismissed(value = {}) {
    let { preferences } = store.getState();
    let { dismissedTodos, todoIds } = preferences;
    let dismissedAt = null;
    let dismissedTodo = dismissedTodos.find((x) =>
      x.startsWith(`${value.id}:`),
    );
    if (!!dismissedTodo)
      dismissedAt = dismissedTodo.slice(dismissedTodo.indexOf(":") + 1);
    if (!!dismissedAt && timeHelpers.wasToday(dismissedAt)) {
      return true;
    }
    return false;
  },
  isInfinite(value, override = null) {
    // return false;
    if (override === true || override === false) {
      return override;
    }
    return value.cycle == 0;

    if (value?.frequency === 0) {
      return true;
    }
    return false;
  },
  isProject(value) {
    // return false;
    return value.cycle == 0;

    if (value?.cycle === 0) {
      return true;
    } else if (!value?.cycle) {
      if (!value?.progress_at?.length) {
        if (valueHelpers.hasGrandChildren(value)) {
          // if (!!value?.child_ids?.length) {
          return true;
        }
      }
    }
    return false;
  },
  isTaskOrTracker(value) {
    return valueHelpers.isTask(value) || valueHelpers.isTracker(value);
  },
  isTask(value) {
    if (!value) value = {};
    return value.cycle === 1 && !value.child_ids?.length;
  },
  isTracker(value) {
    if (!value) value = {};
    // return false;
    return ![null, 1].includes(value.cycle) && !value.child_ids?.length;
    return !!value.cycle && value.cycle > 1 && !value.child_ids?.length;
    // if (value?.cycle === 0) {
    if (
      !!value?.progress_at?.length ||
      !value?.child_ids?.length ||
      !valueHelpers.hasGrandChildren(value)
    ) {
      return true;
    }
    // }
    return false;
  },
  isInfiniteTracker(value) {
    // return false;
    if (valueHelpers.isTracker(value) && valueHelpers.isInfinite(value)) {
      return true;
    }
    return false;
  },
  isReference(value) {
    // if(value?.is_reference){
    if (value?.isReference) {
      return true;
    } else if (value?.text?.includes("_referencing_")) {
      return true;
    } else {
      return false;
    }
  },
  getRefValue(value) {
    if (valueHelpers.isReference(value)) {
      if (!!value.refValue) return value.refValue;

      let values = store.getState().values;
      let refId = parseInt(value.text.split("_referencing_")[1]);
      // console.log("REFID", refId, value.text)
      let ref = values.find((v) => v.id == refId);
      return ref;
    }
    return null;
  },
  generateReference(value) {
    if (valueHelpers.isReference(value)) {
      let refValue = valueHelpers.getRefValue(value);
      if (!!refValue) {
        return {
          ...value,
          refId: refValue.id,
          text: `#${refValue.text}`,
          color: refValue.color,
          icon: refValue.icon,
          refValue,
          isReference: true,
        };
      }
    }
    return null;
  },
  condenseRevisions(value) {
    let revisions = valueHelpers.getRevisions(value);
    console.log("revisions!", revisions);
    let parent_ids = value.parent_ids || [];
    let child_ids = value.child_ids || [];
    let progress_at = value.progress_at;
    for (let r of revisions) {
      parent_ids = textHelpers.uniq([...parent_ids, ...r.parent_ids]);
      child_ids = textHelpers.uniq([...child_ids, ...r.child_ids]);
      progress_at = [...progress_at, ...r.progress_at];
    }
    progress_at = textHelpers.oldestFirst(progress_at);
    return {
      ...value,
      revision_ids: [...revisions.map((r) => r.id), value.id],
      created_at: !!revisions[0] ? revisions[0].created_at : value.created_at,
      progress_at,
      parent_ids,
      child_ids,
    };
  },
  condenseAllRevisions(vals) {
    let values = [...vals];
    let condensedValues = [];
    values = textHelpers.oldestFirst(values, "id");
    for (let i = 0; i < values.length; i++) {
      let value = values[i];
      if (value.is_note) {
        // skip
      } else if (value.root_id == value.id) {
        // console.log("root val", value);
        condensedValues.push({ ...value });
      } else {
        let cvIndex = condensedValues.findIndex(
          (v) => v.root_id == value.root_id,
        );
        if (cvIndex >= 0) {
          let cv = condensedValues[cvIndex];
          if (!cv.revision_ids) {
            cv.revision_ids = [cv.id];
          }
          if (!cv.revisions) {
            // cv.revisions = [cv];
          }
          console.log(`condensing ${value.id} into ${cv.id}`);
          condensedValues[cvIndex] = {
            ...value,
            // revisions: [...cv.revisions, value],
            revision_ids: [...cv.revision_ids, value.id],
            parent_ids: textHelpers.uniq([
              ...value.parent_ids,
              ...cv.parent_ids,
            ]),
          };
        } else {
          let vIndex = values.findIndex((v) => v.root_id == value.root_id);
          // this shouldnt ever happen
          console.warn("this is happening....", value);
        }
      }
    }
    console.log("condensedValues", condensedValues);
    return condensedValues;
  },
  journalValue: {
    id: "journal",
    text: "#Journal",
    icon: "notes",
    parent_ids: [],
    progress_at: [],
    // created_at: new Date().toISOString(),
  },
  filterRichText(...props) {
    return richTextHelpers.filterRichText(...props);
  },
};

export default valueHelpers;
